import {ReactElement} from 'react';
import {spendSaved, perDay} from 'core/LifeCycle';
import {useStateDependentAdapters} from 'ui/adapters';
import {useCoreState} from 'store/utils';

export interface SpendSavedProps {
  oldAmount: number;
  newAmount: number;
  onSelectOption: () => void;
}

export function useSpendHandler(newSettings: CoreState): () => void {
  const callAdapters = useStateDependentAdapters();

  return function saveSettings(): void {
    callAdapters(newSettings);
  };
}

export function SpendSaved({children}: any): ReactElement {
  const oldSettings = useCoreState();
  const newSettings = spendSaved(oldSettings);
  const onSelectOption = useSpendHandler(newSettings);

  return children({
    oldAmount: perDay(oldSettings.budget),
    newAmount: newSettings.dailyBudget.amount,
    onSelectOption,
  });
}
